<template>
    <el-container style="height:inherit;width:100%;">
        <!-- 侧边栏 -->
        <el-aside id="elAside" v-bind:class="{ 'aside-scrollbar':true,activeStyle: isActive, 'text-act': isActives }" >
          <el-scrollbar style="height:100%;">
            <!-- 侧边栏的logo -->
            <div  style="display:flex;padding:22px 0px 20px;justify-content:center;align-items:center; " v-if="isCollapse == false">
              <img src="../../../assets/img/tu3.png" style="width:90px;"/>
            </div>
            <div style="padding:15px 0px;text-align:center;" v-else>
              <!-- <img src="../../../assets/img/tibiot.png" alt="" style="width:26px;"> -->
            </div>
            <!-- 菜单 -->
            <side-list :isCollapse="isCollapse"></side-list>
          </el-scrollbar> 
        </el-aside>
        <el-container style="height:inherit;width:100%;">
            <el-header style="position:relative">
              <!-- 控制菜单伸缩 -->
              <span @click="operationMenu" class="cursors" style="color:#666;position:absolute;top:15px;font-size:26px;">
                <i  style="color:#999;" class="el-icon-s-fold" v-if="isCollapse == false"></i>
                <i  style="color:#999;" class="el-icon-s-unfold" v-else></i>
              </span>
              <!-- 用户的信息和退出 -->
              <div class="signOut" @click="signOut()"><i class="el-icon-switch-button"></i></div>
              <span class="userTitle">{{userName}}</span>
            </el-header>
            <!-- 面包屑 -->
              <el-header id="main-header">
                <el-breadcrumb  style="font-size:15px;">
                  <el-breadcrumb-item v-for="(item,index ) in crumbsArrss" :key="index" :to="{ path: item.url }">{{item.name}}</el-breadcrumb-item>
                </el-breadcrumb>
              </el-header>
            <el-main id="elMain" style="height:100%;">
              <el-scrollbar style="height:100%;" class="main-scorllbar">
                <!-- 主体内容 -->
                <div id="mainView">
                  <transition name="fade-transform" mode="out-in">
                    <router-view style="background: #fff;padding:20px 20px 20px;border-radius:5px;" ></router-view>
                  </transition>
                </div>
                <!-- 返回顶部 -->
                <el-backtop target="#elMain .el-scrollbar__wrap" :bottom="72" :right="22"></el-backtop>
              </el-scrollbar>
            </el-main>
        </el-container>
        <el-dialog
            title="提示"
            :visible.sync="SignOut.show"
            width="500px"
            :close-on-click-modal="false"
            >
            <div style="font-size:20px;text-align:center;">
              <div style="padding-bottom:14px;"><i class="el-icon-warning color_disabled" style="font-size:68px;"></i> </div>
              <span>您确定要退出平台吗？</span> 
            </div>
            <span slot="footer" class="dialog-footer" >
                <el-button size="small" @click="cancel()">取 消</el-button>
                <el-button size="small" type="primary" @click="handleAdopt('SignOut')">确 定</el-button>
            </span>
        </el-dialog>
    </el-container>
    
</template>

<script>
import SideList from './SideList.vue'
import { mapState,mapActions } from "vuex";
  export default {
    name: 'HelloWorld',
    data () {
      return {
        originalVal:[],
        isCollapse:false,
        isActive:true,
        isActives:false,
        SignOut:{
          show:false,
        }
      }
    },
    components:{
      SideList
    },
    computed:{
      ...mapState({  //比如'movies/hotMovies
        userName:state=>state.userName
      }),
      crumbsArrss(){
        let aa =[];
        if((this.$store.state.crumbsArr[0] == undefined) && (this.$store.state.crumbsArr.length != 1)){
          aa = [{name:'首页',url:'/home'}];
          return aa
        }else {
          aa = this.$store.state.crumbsArr;
          return aa;
        }
      }
    },
    created(){
      //获取用户信息
      this.$api.post(this.API.api + 'home/getLoginUserInfo',{},res=>{
        let param={
          userName:res.data.userName,
          name:res.data.name,
          roleId:res.data.roleId,
          roleName:res.data.roleName,
          roleType:res.data.roleType
        }   
        this.saveInfo(param);
      })
    },
    methods:{
      ...mapActions([  //比如'movies/getHotMovies
        'saveInfo',
        'saveMenuWidth'
      ]),
      //(确定))退出
      handleAdopt(){
        this.$api.post(this.API.api + 'home/logOut',{},res=>{
          if(this.$common.getCookie('tibiot-personal-card')){
            document.cookie='tibiot-personal-card='+ this.$common.getCookie('tibiot-personal-card') +';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';  //清除token
            window.localStorage.removeItem("vuex-along"); //清除vue-along
          }
          this.$router.push("./login");
        })
      },
      //取消
      cancel(){
        this.SignOut.show = false; //弹框关闭
        this.$message.info('已取消操作');
      },
      //退出
      signOut(){
        this.SignOut.show = true;
      },
      //菜单收缩
      operationMenu(){
        let a = document.getElementById('elAside');
        this.isCollapse =!this.isCollapse;
        this.isActive = !this.isActive;
        this.isActives = !this.isActives;
        this.saveMenuWidth({menuWidth:(300 - a.offsetWidth)});
      }
    }
  }
</script>
<style scoped>
.el-header {
  background-color:#fff;
  color: #d0d0d0;
}
#main-header{
  background:#F4F4F4;
  height: 34px !important;
}
#main-header>div{
  font-size:14px !important;
  height: 34px !important;
  line-height: 34px!important;
}
#mainView{
  padding:0px 15px;
  box-sizing:border-box;
}
.el-aside {
  background-color: #001529;
}
.el-main {
  background-color: #F4F4F4;
  color: #666;
  padding:0 !important;
}
.signOut{
  float:right;
  margin-top:12px;
  font-size:20px;
  font-weight: bold;
  color:#5d5d5d;
  width:32px;
  height:32px;
  line-height:32px;
  border:1px solid #ccc;
  background: #f5f5f5;
  border-radius:4px;
  text-align:center;
  cursor: pointer;
}
.signOut:hover{
  color:#3BA705;
  border:1px solid #c2e7b0;
  background: #f0f9eb;
}
.phone{
  display: inline-block;
  width:40px;
  height:40px;
  border-radius: 50%;
  overflow: hidden;
}
.phone img{
  width:100%;
}
.userTitle{
  float:right;
  padding-top:21px;
  color:#666;
  padding-right: 12px;
  font-weight: bold;
}
.activeStyle{
  height:inherit !important;
  width:240px !important;
  transition: width 0.2s;
}
.text-act{
  height:inherit !important;
  width:60px !important;
  transition: width 0.2s;
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
<style>
/* 禁止横向滚动条*/
.aside-scrollbar .el-scrollbar__wrap,.main-scorllbar .el-scrollbar__wrap{
  overflow-x: hidden !important;
}


</style>


// WEBPACK FOOTER //
// src/views/pc/components/HelloWorld.vue